import { useEffect, useState } from "react";
import LinkService from "@/app/_services/LinkService";

export type LinkTaxonomy = { name: string; url_name: string };

/**
 * Mediums and sources are FKs whose primary key is the name string, so both the
 * filter dropdowns and the form's comboboxes work with plain strings.
 */
export function useLinkTaxonomy() {
  const [mediums, setMediums] = useState<LinkTaxonomy[]>([]);
  const [sources, setSources] = useState<LinkTaxonomy[]>([]);

  useEffect(() => {
    LinkService.getMediumsAsync()
      .then(setMediums)
      .catch((error) => console.error(error));
    LinkService.getSourcesAsync()
      .then(setSources)
      .catch((error) => console.error(error));
  }, []);

  return { mediums, sources };
}
